import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.583 6.833H10.5l-3.5 3.5-3.5-3.5h2.917V2.75h1.166zm-5.25 5.25h9.334V8h1.166v4.667a.583.583 0 0 1-.583.583H1.75a.583.583 0 0 1-.583-.583V8h1.166z"
    }, null, -1)
  ]))]))
}
export default { render: render }